import TrainerMessengerPreview from "./trainer/TrainerMessengerPreview";

export default function TelegramLocalPreview({ game, contentType }) {
  if (contentType === "trainer") {
    const firstQuestion = (game?.trainerQuestions ?? []).find((item) =>
      item?.questionText?.trim()
    );

    return (
      <div className="tg-local-preview">
        <TrainerMessengerPreview
          embedded
          title={game?.title}
          theme={game?.trainerTheme}
          description={game?.description}
          poster={game?.poster}
          previewMode={firstQuestion ? "question" : "welcome"}
          question={firstQuestion}
        />
      </div>
    );
  }

  if (contentType === "knowledge_base") {
    const items = (game?.kbItems ?? []).filter((item) => item?.question?.trim());
    const title = game?.title || "База знаний";
    const theme = game?.kbTheme?.trim();

    return (
      <div className="tg-local-preview">
        <article className="tg-bubble tg-bubble--info">
          <p className="tg-bubble__text">
            Карманная база знаний «{title}»
            {theme ? ` · ${theme}` : ""}
          </p>
          <p className="tg-bubble__text tg-bubble__text--muted">
            Выберите вопрос — бот покажет ответ текстом или видео.
          </p>
        </article>
        <div className="tg-scene-buttons">
          {items.map((item) => (
            <button
              key={item.id}
              type="button"
              className="tg-scene-button tg-scene-button--static"
              disabled
            >
              {item.question}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return null;
}
